import { t } from "i18next";
import QRCode from "react-qr-code";
import styled from "styled-components";
import { Pending } from "./Pending";
import { Redeemed } from "./Redeemed";
import { Used } from "./Used";

interface IProps {
    titleReward?: string;
    totleReward?: string;
    textButton?: string;
    imgReward?: string;
    dateReward?: string;
    themeColor?: string;
    textNote?: string;
}

export const ResultSpin = (props: IProps) => {
    return (
        <StlyedResultSpin>
            <div className="layout-top-content">
                <div className="img-main-reward">
                    <img src={props.imgReward || "../../images/img-discount.svg"} alt="" />
                </div>
                <div className="title-main-reward">{props.titleReward || "Robinhood 20% Off"}</div>
                <div className="total-main-reward">{props.totleReward || "x3 Coupons"}</div>
                <div className="date-main-reward">EXP : {props.dateReward || "1 Feb - 30 Mar 2023"}</div>
            </div>
            <div className="layout-bottom-content">
                <div className="action-layout">
                    <div className="qr-layout">
                        <div className="qr-box">
                            <QRCode
                                value={"google.com"}
                                size={150}
                            />
                        </div>
                        <StyledCodeButton
                            mainColor={props.themeColor}
                        >
                            ----
                        </StyledCodeButton>
                    </div>
                    <p className="redeemed-product">
                        <span className="redeemed">
                            <Redeemed color="#336C51" />
                        </span>
                        Redeemed
                    </p>
                    <p className="pending-product">
                        <span className="pending">
                            <Pending color="#ED773A" />
                        </span>
                        Pending
                    </p>
                    <p className="used-product">
                        <span className="used">
                            <Used color="#336C51" />
                        </span>
                        Used
                    </p>
                    <p className="note">
                        {props.textNote || "TextNote"}
                        {t("page.desConfirm")}
                    </p>
                </div>
            </div>
        </StlyedResultSpin>
    );
};

const StyledCodeButton = styled.div<{ mainColor?: string }>`
    position: absolute;
    background: ${(p) => p.mainColor};
    border-radius: 80px;
    height: 26px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    bottom: 0;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #ffffff;
`;

const StyledBtnSpinMission = styled.button`
    font-size: 13px;
    line-height: 15px;
    font-weight: 600;
    padding: 15px 12px;
    border-radius: 12px;
    width: 100%;
    background-color: #ffe212;
    color: #000;
    border: none;
`;

const StlyedResultSpin = styled.div`
    position: relative;
    margin-bottom: 10px;
    .img-main-reward {
        display: inline-block;
        border-radius: 100%;
        text-align: center;
        margin-bottom: 10px;
        overflow: hidden;
        margin-top: -75px;
        img {
            width: 150px;
            height: 150px;
            object-fit: cover;
        }
    }
    .title-main-reward {
        font-size: 18px;
        line-height: 21px;
        font-weight: 600;
        color: #000;
        margin-bottom: 10px;
        text-align: center;
    }
    .total-main-reward {
        font-size: 14px;
        line-height: 20px;
        color: #E53223;
        margin-bottom: 10px;
        text-align: center;
    }
    .layout-top-content {
        text-align: center;
        padding-bottom: 30px;
        margin-bottom: 15px;
        border-bottom: 0.5px solid #ddd;
    }
    .layout-bottom-content {
        text-align: center;
        .action-layout {
            padding: 8px 24px 24px 24px;
            // background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .code-qr {
                font-weight: 700;
                font-size: 20px;
                line-height: 24px;
                color: #000;
                text-align: center;
            }
            .redeemed-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .pending-product {
                text-align: center;
                font-size: 12px;
                color: #ed773a;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .used-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                color: #9b9b9b;
            }
        }
    }
`;